import { Typography, Box, Badge, Skeleton, Tooltip } from "@mui/material";
import CustomAvatar from "src/components/shared/atoms/avatar/customAvatar";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useStyles from "./Styles";

const MAX_NAME_LENGTH = 16;
const MAX_ROLE_LENGTH = 20;

const ProfileBox = () => {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const { me }: any = useSelector((state: any) => state.me);
  const { picture, onlineStatus, name, designation } = me ?? {};
  const paneltype = designation?.paneltype?.toLowerCase();

  const renderWithTooltip = (
    value?: string,
    className?: string,
    maxLength: number = 16,
  ) => {
    if (!value) return null;

    const needsTooltip = value.length > maxLength;
    const displayValue = needsTooltip
      ? `${value.substring(0, maxLength)}...`
      : value;

    const text = (
      <Typography variant="body1" mr={2} className={className}>
        {displayValue}
      </Typography>
    );

    return needsTooltip ? (
      <Tooltip title={value} arrow placement="top">
        {text}
      </Tooltip>
    ) : (
      text
    );
  };

  return (
    <Box
      className={classes.profileBox}
      onClick={() => navigate("/settings/profile")}
    >
      <Badge
        color={onlineStatus ? "secondary" : "error"}
        badgeContent=" "
        variant="dot"
        overlap="circular"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <CustomAvatar src={picture} alt={name} />
      </Badge>
      <Box className={classes.appBarContainer}>
        {name ? (
          renderWithTooltip(name, classes.profileUserName, MAX_NAME_LENGTH)
        ) : (
          <Skeleton
            animation="wave"
            variant="text"
            sx={{ width: "12vh", height: "3vh" }}
          />
        )}
        {paneltype ? (
          renderWithTooltip(paneltype, classes.profileUserRole, MAX_ROLE_LENGTH)
        ) : (
          <Skeleton
            animation="wave"
            variant="text"
            sx={{ width: "12vh", height: "3vh" }}
          />
        )}
      </Box>
    </Box>
  );
};

export default ProfileBox;
